import { FAQ_ITEMS } from '../../constants/faq';

import FAQItem from './FAQItem';

export default function FAQ() {
  const items = FAQ_ITEMS;

  return (
    <section
      className="py-12 sm:py-16 md:py-20 max-w-4xl mx-auto px-4"
      id="faqs">
      <h2 className="text-center text-2xl sm:text-3xl font-semibold mb-2">
        Frequently Asked Questions
      </h2>
      <p className="text-gray-600 text-sm sm:text-base text-center max-w-2xl mx-auto mb-4">
        Have questions? We’ve got answers to some of the most common inquiries
        and things you might be wondering about.
      </p>
      <div className="space-y-4">
        {items.map((item, i) => (
          <FAQItem key={i} index={i} item={item} />
        ))}
      </div>
    </section>
  );
}
